import type { FC } from 'react';

import { HelpImage } from '@pp/core/src/components/help/utils/HelpImage';
import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';

import LastResults from '../../../../assets/helpAssets/LastResults.png';

export const CrashHelpChapterLastResults: FC = () => {
  return (
    <div>
      <p>
        <HelpText tk="lastResultHF.lastResult" markdown />
      </p>
      <ul>
        <li>
          <HelpText tk="lastResultHF.countdown" />
        </li>
        <li>
          <HelpText tk="lastResultHF.inPlay" />
        </li>
        <li>
          <HelpText tk="lastResultHF.colouredResult" />
        </li>
      </ul>
      <HelpImage url={LastResults} alt="LastResults" />
    </div>
  );
};
